<div class="padding-20 ui-g" *ngIf="show.form" id="touchpointCouponForm">
  <br />
  <div>

<p-confirmDialog key="resetDialog"></p-confirmDialog>
</div>

  <!-- LAYOUT DI DEFAULT FRUIZIONE -->
  <div class="ui-g-12">
    <div class="layoutDefaultContainer">
      <button pButton type="button" data-testid="layout"
        [ngClass]="{'notPermitted': readOnly==true, 'layoutDone': fieldModel.layoutDefaultValue}"
        class="layoutDefaultFirstBtn" icon="fa fa-edit" iconPos="left" label="{{'campaign.layout_default' | translate}}"
        (click)="onClickLayoutDefault()"></button>
      <br />
      <br />
    </div>
  </div>


  <!-- TOUCHPOINT EMISSIONE -->
  <div class="ui-g-6 ui-g">
    <div class="ui-g-12 labelTitle">
      <span>{{ 'campaign.touchpoint_emission' | translate }}</span>
      <span class="asterix">&nbsp;*</span>
    </div>
    <br />
    <br />
    <br />
    <div class="ui-g-12 switch">


      <!-- emission offline -->
      <div class="ui-g-12" *ngIf="touchpoints.E.OFF && touchpoints.E.OFF.length>0">
        <br />

        <app-form-fields #switchOfflineEmissione data-testid="switchOfflineEmissione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_offline_emissione" (fieldModelChange)="onChangeSwitch('E','OFF',$event)"
          [(fieldModel)]="switch.E.OFF"></app-form-fields>
        <br />
      </div>
      <div class="ui-g-12 ui-g">

        <!-- emission offline -->
        <div class="ui-g ui-g-12" [ngClass]="{'notPermitted': readOnly==true}">
          <div *ngFor="let tp of touchpoints.E.OFF;let i=index;" class="generalList ui-g-12"
            [ngClass]="{'touchpointActive pointer': switch.E.OFF == true, 'touchpointInactive notAllowed': switch.E.OFF == false}">


            <div class="ui-g-1 colTouchpoint" *ngIf="tp.active && tp.preview_url && tp.code_preview">
              <button pButton type="button" class="layoutBtn anteprimaBtn colTouchpointDone" icon="fa fa-file"
                iconPos="left" pTooltip="{{ 'cluster_ochannel.preview' | translate }}"
                (click)="anteprimaCoupon(tp)"></button>
            </div>


            <div class="ui-g-3 colTouchpoint">
              <button pButton type="button" [ngClass]="{'colTouchpointDone': tp.active == true}"
                class="touchpointNameButton" label="{{tp.description}}"
                (click)="onClickTouchpointNameButton('E','OFF',i)"></button>
            </div>
            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">
              <button pButton type="button" [attr.data-testid]="'colTouchpointEmissioneOfflineStores' + tp.code"
                [ngClass]="{'mandatoryError': !tp.valid && (!tp.negoziModel || tp.negoziModel.length==0), 'colTouchpointDone': (tp.negoziModel && tp.negoziModel.length>0)}"
                class="negoziBtn" icon="fa fa-edit" iconPos="left" label="{{'campaign.stores' | translate}}"
                (click)="onClickNegoziBtn('E','OFF',i)">

              </button>
              <div *ngIf="!tp.valid && (!tp.negoziModel || tp.negoziModel.length==0)" class="errorMessage">
                {{'common.required_error' | translate}}</div>
            </div>

            <!-- I layout sono definiti solo per emissione -->
            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">
              <button pButton type="button" [attr.data-testid]="'colTouchpointEmissioneOffline' + tp.code"
                [ngClass]="{'mandatoryError': !tp.valid && (!tp.layoutValue && tp.acceptLayoutDefault && !fieldModel.layoutDefaultValue), 'colTouchpointDone': tp.layoutOwnSet==true,'layoutDefault': tp.layoutDefaultSet == true}"
                class="layoutBtn" icon="fa fa-edit" iconPos="left" label="Layout"
                (click)="onClickLayoutBtn('E','OFF',i)"></button>
              <div *ngIf="!tp.valid && (!tp.layoutValue && tp.acceptLayoutDefault && !fieldModel.layoutDefaultValue)"
                class="errorMessage">{{'common.required_error' | translate}}</div>
            </div>

            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">
              <button pButton type="button" class="negoziBtn" icon="fa fa-eraser"
                pTooltip="{{ 'campaign.resetLayout' | translate }}" tooltipPosition="top"
                (click)="confirmResetTouchpoint('E','OFF',i)">
              </button>
            </div>


            <!-- RULESTOUCHPOINT -->

            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true && tp.rules=='1'">
              <button pButton type="button" [attr.data-testid]="'colTouchpointEmissionOfflineRules' + tp.code"
                [ngClass]="{ 'colTouchpointDone': hasRules('emission', tp.ochannel_id) }" class="layoutBtn"
                icon="fa fa-edit" iconPos="left" label="{{'campaign.rules' | translate}}"
                (click)="onCreateRulesButton('emission','OFF',i,tp)">
              </button>
            </div>



          </div>
        </div>


        <!-- emission online -->
        <div class="ui-g-12" *ngIf="touchpoints.E.ON && touchpoints.E.ON.length>0">
          <br />

          <app-form-fields #switchOnlineEmissione data-testid="switchOnlineEmissione" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.switch_online_emissione" (fieldModelChange)="onChangeSwitch('E','ON',$event)"
            [(fieldModel)]="switch.E.ON"></app-form-fields>
          <br />
        </div>
        <div class="ui-g-12 ui-g sortable-list" [ngClass]="{'notPermitted': readOnly==true}">
          <div *ngFor="let tp of touchpoints.E.ON;let i=index;" class="generalList ui-g-12" draggable="true"
            (dragstart)="onDragStart($event,'E','ON', i)" (dragover)="onDragOver($event,'E','ON',i)"
            (drop)="onDrop($event, 'E','ON',i)"
            [ngClass]="{'touchpointActive pointer': switch.E.ON == true, 'touchpointInactive notAllowed': switch.E.ON == false}">
            <div [attr.data-testid]="'onlineTouchpointNameButton' + tp.code"
              class="ui-g-3 colTouchpoint touchpointName">
              <button pButton type="button" [ngClass]="{'colTouchpointDone': tp.active == true}"
                class="touchpointNameButton" label="{{tp.description}}"
                (click)="onClickTouchpointNameButton('E','ON',i)"></button>
            </div>

            <!-- OSS: I negozi sono definiti solo per gli offline -->

            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">
              <button pButton type="button" [attr.data-testid]="'colTouchpointEmissioneOnline' + tp.code"
                [ngClass]="{'mandatoryError': !tp.valid && (!tp.layoutValue && tp.acceptLayoutDefault && !fieldModel.layoutDefaultValue), 'colTouchpointDone': tp.layoutOwnSet==true,'layoutDefault': tp.layoutDefaultSet == true}"
                class="layoutBtn" icon="fa fa-edit" iconPos="left" label="{{'campaign.layout' | translate}}"
                (click)="onClickLayoutBtn('E','ON',i)"></button>
              <div *ngIf="!tp.valid && (!tp.layoutValue && tp.acceptLayoutDefault && !fieldModel.layoutDefaultValue)"
                class="errorMessage">{{'common.required_error' | translate}}</div>
            </div>


            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">
              <button pButton type="button" class="negoziBtn" icon="fa fa-eraser"
                pTooltip="{{ 'campaign.resetLayout' | translate }}" tooltipPosition="top"
                (click)="confirmResetTouchpoint('E','ON',i)">
              </button>
            </div>
            <!-- RULESTOUCHPOINT -->


            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true && tp.rules=='1'">
              <button pButton type="button" [attr.data-testid]="'colTouchpointEmissionOnlineRules' + tp.code"
                [ngClass]="{ 'colTouchpointDone': hasRules('emission', tp.ochannel_id) }" class="layoutBtn"
                icon="fa fa-edit" iconPos="left" label="{{'campaign.rules' | translate}}"
                (click)="onCreateRulesButton('emission','ON',i,tp)">
              </button>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>


  <!-- TOUCHPOINT FRUIZIONE -->
  <div class="ui-g-6 ui-g">
    <div class="ui-g-12 labelTitle">

      <span>{{ 'campaign.touchpoint_fruition' | translate }}</span>

      <span class="asterix">&nbsp;*</span>
    </div>
    <br />
    <br />
    <br />
    <div class="ui-g-12 switch">


      <!-- fruition offline -->
      <div class="ui-g-12" *ngIf="touchpoints.F.OFF && touchpoints.F.OFF.length>0">
        <br />

        <app-form-fields #switchOfflineFruizione data-testid="switchOfflineFruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_offline_fruizione" (fieldModelChange)="onChangeSwitch('F','OFF',$event)"
          [(fieldModel)]="switch.F.OFF"></app-form-fields>
        <!--       <app-form-fields #switchOfflineComeEmissione data-testid="switchOfflineComeEmissione" [disabled]="switch.F.OFF == false" [readOnly]="readOnly" [fieldSchema]="formSchema.form.switch_offline_come_emissione" (fieldModelChange)="onChangeSwitchAsEmissionOff($event)" [(fieldModel)]="switch.F.AS_EMISSION_OFF"></app-form-fields>
 -->
        <button class="dateButton" data-test-id="as_emission" (click)="onChangeSwitchAsEmissionOff_new()"
          [disabled]="AsEmissionDisabled">

          <span>{{ 'campaign.as_emission' | translate }}</span>

        </button>


        <div class="clear_fix"></div>
        <br />
      </div>
      <div class="ui-g-12 ui-g">

        <!-- fruition offline -->
        <div class="ui-g ui-g-12" [ngClass]="{'notPermitted': readOnly==true}">
          <div *ngFor="let tp of touchpoints.F.OFF;let i=index;" class="generalList ui-g-12"
            [ngClass]="{'touchpointActive pointer': switch.F.OFF == true, 'touchpointInactive notAllowed': switch.F.OFF == false}">

            <div class="ui-g-3 colTouchpoint touchpointName">
              <button pButton type="button" [ngClass]="{'colTouchpointDone': tp.active == true}"
                class="touchpointNameButton" label="{{tp.description}}"
                (click)="onClickTouchpointNameButton('F','OFF',i)"></button>
            </div>
            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true">

              <button pButton type="button" [attr.data-testid]="'colTouchpointFruzioneOffline' + tp.code" [ngClass]="{
                'mandatoryError': !tp.valid && (!tp.negoziModel || tp.negoziModel.length == 0),
                'colTouchpointDone': (tp.negoziModel && tp.negoziModel.length > 0)
              }" class="negoziBtn " (click)="onClickNegoziBtn('F','OFF',i)" icon="fa fa-edit" iconPos="left"
                label="{{'campaign.stores' | translate}}">

              </button>
              <!--
              <div *ngIf="!tp.valid && (!tp.negoziModel || tp.negoziModel.length==0)" class="errorMessage">
                <span *ngIf="language == 'it'">{{'common.required_error' | translate}}</span>
                <span *ngIf="language == 'en'">{{'common.required_error' | translate}}</span>
              </div>
            </div>
          -->
              <div *ngIf="!tp.valid && (!tp.negoziModel || tp.negoziModel.length==0)" class="errorMessage">
                {{'common.required_error' | translate}}</div>
            </div>

            <!-- RULESTOUCHPOINT -->

            <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true && tp.rules=='1'">
              <button pButton type="button" [attr.data-testid]="'colTouchpointFruitionOfflineRules' + tp.code"
                [ngClass]="{ 'colTouchpointDone': hasRules('fruition',tp.ochannel_id) }" class="layoutBtn"
                icon="fa fa-edit" iconPos="left" label="{{'campaign.rules' | translate}}"
                (click)="onCreateRulesButton('fruition','OFF',i,tp)">
              </button>

              <div *ngIf="!tp.valid && (!tp.layoutValue && tp.acceptLayoutDefault && !fieldModel.layoutDefaultValue)"
                class="errorMessage">{{'common.required_error' | translate}}</div>
            </div>

            <div class="ui-g-4 ui-g colTouchpoint" [ngClass]="{'formHidden': formSchema.form.wizard.visible == false }">



            </div>


          </div>


          <!-- fruition online -->
          <div class="ui-g-12" *ngIf="touchpoints.F.ON && touchpoints.F.ON.length>0">
            <br />

            <app-form-fields #switchOnlineFruizione data-testid="switchOnlineFruizione" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.switch_online_fruizione"
              (fieldModelChange)="onChangeSwitch('F','ON',$event)" [(fieldModel)]="switch.F.ON"></app-form-fields>
            <app-form-fields #switchOnlineComeEmissione data-testid="switchOnlineComeEmissione"
              [disabled]="switch.F.ON == false" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.switch_online_come_emissione"
              (fieldModelChange)="onChangeSwitchAsEmissionOn($event)"
              [(fieldModel)]="switch.F.AS_EMISSION_ON"></app-form-fields>
            <div class="clear_fix"></div>
            <br />
          </div>
          <div class="ui-g-12 ui-g" [ngClass]="{'notPermitted': readOnly==true}">
            <div *ngFor="let tp of touchpoints.F.ON;let i=index;" class="generalList ui-g-12"
              [ngClass]="{'touchpointActive pointer': switch.F.ON == true, 'touchpointInactive notAllowed': switch.F.ON == false}">
              <div class="ui-g-3 colTouchpoint touchpointName">
                <button pButton type="button" [ngClass]="{'colTouchpointDone': tp.active == true}"
                  class="touchpointNameButton" label="{{tp.description}}"
                  (click)="onClickTouchpointNameButton('F','ON',i)"></button>
              </div>
              <!-- RULESTOUCHPOINT -->
              <div class="ui-g-2 colTouchpoint" *ngIf="tp.active==true && tp.rules=='1'">
                <button pButton type="button" [attr.data-testid]="'colTouchpointFruitionOnlineRules' + tp.code"
                  [ngClass]="{ 'colTouchpointDone': hasRules('fruition',tp.ochannel_id) }" class="layoutBtn"
                  icon="fa fa-edit" iconPos="left" label="{{'campaign.rules' | translate}}"
                  (click)="onCreateRulesButton('fruition','ON',i,tp)">
                </button>
              </div>

            </div>

          </div>



        </div>
      </div>
    </div>

  </div>


  <!-- modal negozi -->
  <!--   <p-dialog *ngIf="show.modalStores" [width]="1500" [height]="800" [(visible)]="show.modalStores" [responsive]="true"
    [header]="'campaign.add_stores' | translate" showEffect="fade" [modal]="true" data-testid="add_stores_form">

    <app-campaign-3-search-stores #searchStores data-testid="searchStores" [readOnly]="readOnly" [groupList]="groupList"
      [insegneList]="insegneList" [areeList]="areeList" [storesList]="list.stores" (storesListCancel)="onStoresCancel()"
      (storesListSelected)="onStoresSelected($event)"></app-campaign-3-search-stores>

  </p-dialog>
 -->


  <p-dialog *ngIf="show.modalStoresEmission" [width]="1500" [height]="800" [(visible)]="show.modalStoresEmission"
    [responsive]="true" [header]="'campaign.add_stores' | translate" showEffect="fade" [modal]="true"
    data-testid="add_stores_emission_form">

    <app-campaign-3-search-stores [readOnly]="readOnly" [groupList]="groupList" [insegneList]="insegneList"
      [areeList]="areeList" [storesList]="list.stores.emission" (storesListCancel)="onStoresCancel('E')"
      (storesListSelected)="onStoresSelected($event, 'E')">
    </app-campaign-3-search-stores>
  </p-dialog>

  <p-dialog *ngIf="show.modalStoresFruition" [width]="1500" [height]="800" [(visible)]="show.modalStoresFruition"
    [responsive]="true" [header]="'campaign.add_stores' | translate" showEffect="fade" [modal]="true"
    data-testid="add_stores_fruition_form">

    <app-campaign-3-search-stores [readOnly]="readOnly" [groupList]="groupList" [insegneList]="insegneList"
      [areeList]="areeList" [storesList]="list.stores.fruition" (storesListCancel)="onStoresCancel('F')"
      (storesListSelected)="onStoresSelected($event, 'F')">
    </app-campaign-3-search-stores>
  </p-dialog>


  <!-- modal per ricerca wizard -->

  <!--  <p-dialog *ngIf="show.modalWizard" [width]="1500" [height]="800" [(visible)]="show.modalWizard" [responsive]="true"
  [header]="{{ 'campaign.select_wizard' | translate }}"
  showEffect="fade" [modal]="true">

    <app-campaign-3-search-wizard #searchWizard (wizardSelected)="onWizardSelected($event)"
      [wizardList]="wizardList"></app-campaign-3-search-wizard>


    <div class="ui-dialog-footer buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalWizard()" type="button" class="k-generic-btn footer-btn"
        label="{{'common.cancel' | translate}}"></button>
      <div class="clear_fix"></div>
    </div>

  </p-dialog> -->

  <!-- modal per layout -->

  <p-dialog *ngIf="show.modalLayoutDefault" [width]="1500" [height]="800" [(visible)]="show.modalLayoutDefault"
    [responsive]="true" [header]="'Layout'" showEffect="fade" [modal]="true" class="campaign-dialog fixed-title-dialog"
    focusOnShow="true">
    <button class="phantom-button" autofocus></button>

    <app-kv-json-form-schema *ngIf="layoutDefault && show.modalLayoutDefault" [readOnly]="readOnly"
      [formData]="layoutDefault" (formSubmitted)="saveLayout($event)" (formClosed)="show.modalLayoutDefault = false">
    </app-kv-json-form-schema>
  </p-dialog>

  <!--- Anteprima coupon -->
  <p-dialog class="campaign-dialog" *ngIf="showPreview" [(visible)]="showPreview" [positionTop]="40"
    [positionLeft]="'50%'" [header]="'campaign.previewCoupon' | translate" [modal]="true" [draggable]="false"
    [closable]="true">
    <div *ngIf="showPreviewError" style="color: #d00;"> {{ showPreviewError}} </div>
    <img [src]="imagePath">
  </p-dialog>



  <!-- modale per le regole -->

  <p-dialog *ngIf="show.modalForRules" [width]="1500" [height]="800" [(visible)]="show.modalForRules"
    [responsive]="true" [header]="'campaign.touchpointRules' | translate" showEffect="fade" [modal]="true"
    class="campaign-dialog fixed-title-dialog" focusOnShow="true">
    <button class="phantom-button" autofocus></button>

    <app-touchpoint-rule-popup (rulesCreated)="onRulesCreated($event)" [idTouchpoint]="touchpointid"
      [scope]="futureScopeRule" [miId]="messageInstanceObject.id" [rulesData]="ruleObjectTypeResponse"
      [miObjectTypesList]="miObjectTypesList" [miRuleTypesList]="miRuleTypesList" [targetScope]="targetScope"
      [ruleToEdit]="ruleToEdit" [language]="language"></app-touchpoint-rule-popup>
  </p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-touchpoint/campaign-3-touchpoint.component.html